<template>
  <div class="paper-exam">
    <div class="title">基本信息</div>
    <Form ref="exam" :model="exam" :rules="ruleExam" :label-width="120">
      <FormItem label="考试名称" prop="name">
        <Input
          v-model="exam.name"
          :maxlength="30"
          placeholder="请输入考试名称，不能超过30个字"
          style="width: 400px;"
          clearable
        ></Input>
        <span style="padding-left: 10px;">{{exam.name.length}}/30</span>
      </FormItem>
      <FormItem label="考试分类" prop="classify_ids">
        <Cascader
          :data="catagoris"
          v-model="exam.classify_ids"
          trigger="hover"
          style="width:200px;"
          change-on-select
        ></Cascader>
      </FormItem>
      <FormItem label="封面图片" prop="indexpic">
        <UploadFile
          url="/api/public/img"
          :format="['jpg','jpeg','gif','png']"
          @onSuccess="onUploadSuccess"
        ></UploadFile>
        <div class="tip">*尺寸为 220 * 220, 请上传jpg, png格式的图片, 建议图片大小不超过2MB。</div>
        <div v-if="exam.indexpic">
          <img :src="exam.indexpic" style="width:88px;height:88px;" />
        </div>
      </FormItem>
      <FormItem label="详情页封面图" prop="mainpic">
        <UploadFile
          url="/api/public/img"
          :format="['jpg','jpeg','gif','png']"
          @onSuccess="onUploadMainSuccess"
        ></UploadFile>
        <div class="tip">*尺寸为 375 * 209, 请上传jpg, png格式的图片, 建议图片大小不超过2MB。</div>
        <div v-if="exam.mainpic">
          <img :src="exam.mainpic" style="width:150px;height:84px;" />
        </div>
      </FormItem>
      <FormItem label="考卷详情：" prop="description">
         <UEditor v-model="exam.description"></UEditor>
        <!-- <Input
          v-model="exam.description"
          :maxlength="150"
          placeholder="请输入考卷详情，不能超过150个字"
          style="width: 400px;"
          type="textarea"
        ></Input> -->
        <span style="padding-left: 10px;">{{exam.description.length}}/150</span>
      </FormItem>
      <FormItem label="选择试卷：" prop="papers">
        <Tag
          type="border"
          closable
          v-for="paper in exam.papers"
          :key="paper.id"
          @on-close="paperDelete()"
        >{{paper.name}}</Tag>
        <Button :disabled="id > 0" type="default" @click="showSelectPapers=true">
          <i class="ivu-icon ivu-icon-ios-add"></i>添加试卷
        </Button>
      </FormItem>
      <FormItem label="是否关联课程" prop="related_course_id">
        <RadioGroup v-model="exam.is_related_course">
          <Radio :label="1" value="1">是</Radio>
          <Radio :label="0" value="0">否</Radio>
        </RadioGroup>
        <div v-if="exam.is_related_course">
          <Tag v-if="exam.related_course_id>0"
            type="border"
            closable @on-close="coueseDelete()"
          >{{exam.related_course.title}}</Tag>
          <Button type="default" @click="showSelectCourse=true">
            <i class="ivu-icon ivu-icon-ios-add"></i>选择课程
          </Button>
        </div>
      </FormItem>
      <div class="title">考试设置</div>
      <FormItem label="考试时长：" prop="limit_time">
        <Input v-model="exam.limit_time" placeholder="请输入时长" style="width: 50px;" type="number"></Input>分钟
      </FormItem>
      <FormItem label="通过分数：">
        <Input v-model="exam.pass_score" placeholder="请输入" style="width: 50px;" type="number"></Input>分
        <span>试卷总分：{{exam.papers[0] ? exam.papers[0].score : 100}}分</span>
      </FormItem>
      <div class="title">上架信息</div>
      <FormItem label="售卖设置">
        <RadioGroup v-model="exam.is_free">
          <Radio :label="1">
            <span>付费</span>
          </Radio>
          <Radio :label="2">
            <span>免费</span>
          </Radio>
        </RadioGroup>
        <div v-if="exam.is_free == 1" style="margin-left:-60px;">
          <FormItem label="考试价格" prop="price" class="form-item-child" style="margin-bottom:24px;">
            <Input style="width:150px" type="text" v-model="exam.price" placeholder="请输入价格" />
            <span class="tip">必须填写大于0的自然数</span>
          </FormItem>
        </div>
      </FormItem>
      <FormItem label="销售基数" prop="sales_base">
        <Input v-model="exam.sales_base" placeholder="请输入"   style="width: 100px;" type="number"></Input>
        <span>销售基数使前端展示的销售量有虚拟增加</span>
      </FormItem>
      <AttrSelect class="attr-select" form-url="/api/module/attribute/5" :attr="exam.attr" @onChange="onAttrChange"></AttrSelect>
      <FormItem style="text-align:center">
        <Button size="large" :to="{name: 'QuestionExamManage'}">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submitForm('exam')"
        >保存并返回</Button>
      </FormItem>
    </Form>
    <Modal
      class="grid-select"
      v-model="showSelectPapers"
      title="选择试卷"
      @on-ok="confirmSelectPapers"
      @on-cancel="$refs.paper.recoverSelectedItems(exam.papers)"
      width="800"
      scrollable
    >
      <Paper ref="paper" :selectedItems="exam.papers"></Paper>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectStudent"
      title="选择学员"
      @on-ok="confirmSelectStudent"
      @on-cancel="$refs.student.recoverSelectedItems(students)"
      width="800"
      scrollable
    >
      <StudentSelect ref="student" :selectedItems="students"></StudentSelect>
    </Modal>
    <Modal
      class="grid-select"
      v-model="showSelectCourse"
      title="选择课程"
      @on-ok="confirmSelectCourse"
      @on-cancel="$refs.course.recoverSelectedItems(exam.courses)"
      width="800"
      scrollable
    >
      <CourseSelect ref="course" :selectedItems="courses" :selectType="courseSelecttype"></CourseSelect>
    </Modal>
  </div>
</template>

<script>
import Paper from "@/components/GridSelect/PaperSelect";
import StudentSelect from "@/components/GridSelect/StudentSelect";
import CourseSelect from "@/components/GridSelect/CourseSelect";
import UploadFile from "@/components/UploadFile.vue";
import AttrSelect from '@/components/AttrSelect';
import UEditor from "@/components/UEditor.vue";

export default {
  name: "QuestionExamAdd",
  components: {
    Paper,
    StudentSelect,
    CourseSelect,
    AttrSelect,
    UploadFile,
    UEditor
  },
  async created() {
    let catagoris = await this.$http.get("/api/course/classify");
    this.catagoris = catagoris;
    if( this.id ) {
      this.requestExam();

    }
  },
  data() {
    return {
      id: this.$route.query.id,
      exam: {
        name: "",
        indexpic: "",
        mainpic: "",
        description: "",
        papers: [],
        is_start_notice: "2",
        notice_before_time: 0,
        limit_time: null,
        pass_score: 0,
        repeat_times: -1,
        uid: "0",
        is_free: 2,
        simulation_type: 1,
        related_course_id: 0,
        related_course: {
          name: ''
        },
        is_related_course: 0,
        start_time: 0,
        end_time: 0,
        attr:[]
      },
      students: [],
      ruleExam: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        classify_ids: [{ required: true, message: "请选择考试分类"}],
        indexpic: [{ required: true, message: "请上传封面图" }],
        mainpic: [{ required: true, message: "请上传详情页封面图" }],
        papers: [
          {
            required: true,
            type: "array",
            message: "请选择试卷",
            trigger: "change"
          }
        ],
        // limit_time: [{ required: true, message: "请输入" }]
      },
      showSelectPapers: false,
      showSelectStudent: false,
      showSelectCourse: false,
      catagoris: [],
      courses: [],
      courseSelecttype: 'single'
    };
  },
  methods: {
    requestExam() {
      this.$http.get(`/api/exam/packageSimulation/`+ this.id).then(
        (data) => {
          this.exam = data;
          this.exam.classify_ids = [data.classify_id, 0 ];
          this.exam.papers = [
            {
              id: data.exam_id,
              name: data.exam_name,
              score: data.score
             }
          ]
          // this.exam.is_related_course = data.related_course_id > 0 ? 1 : 0;
          // this.exam.is_free = data.price > 0 ? 1 : 2;
          this.$set(this.exam,'is_related_course',data.related_course_id > 0 ? 1 : 0);
          this.$set(this.exam,'is_free',data.price > 0 ? 1 : 2)
          this.exam.price = data.price/100;

          let classifyList = [data.classify_id,0];
          for (let i = 0; i < this.catagoris.length; i++) {
            let classify = this.catagoris[i];
            if (classify.value == data.classify_id) {
              classifyList.push(classify.value);
              classifyList.push(0);
              break;
            }
            if (classify.children) {
              let c;
              for (c = 0; c < classify.children.length; c++) {
                let child = classify.children[c];
                if (child.value == data.classify_id) {
                  classifyList.push(classify.value);
                  classifyList.push(child.value);
                  break;
                }
              }
              if (c < classify.children.length) {
                break;
              }
            }
          }
          this.exam.related_course = data.related_course || { name: ''}
          this.exam.classify_ids = classifyList;
          this.exam.attr = data.exam_attr;
      });
    },
    onUploadSuccess(data) {
      this.exam.indexpic = data.path;
    },
    onUploadMainSuccess(data) {
      this.exam.mainpic = data.path;
    },
    onAttrChange(val) {
      this.exam.exam_attr = val
    },
    confirmSelectPapers() {
      this.showSelectPapers = false;
      let list = this.$refs.paper.getSelectList();
      this.exam.papers = list;
      this.exam.pass_score = parseInt(list[0].pass_score);
    },
    confirmSelectStudent() {
      this.showSelectStudent = false;
      let list = this.$refs.student.getSelectList();
      this.students = list;
    },
    confirmSelectCourse() {
      this.showSelectCourse = false;
      let list = this.$refs.course.getSelectList();
      this.courses = list;
      this.exam.related_course_id = list[0].id;
      this.exam.related_course.title = list[0].title;
    },
    paperDelete() {
      this.exam.papers = [];
    },
    coueseDelete() {
      this.courses = [];
      this.exam.related_course_id = 0;
      this.exam.related_course.title = '';
    },
    studentDelete(uid) {
      let students = this.students;
      if (uid) {
        for (let i = 0; i < students.length; i++) {
          if (students[i].uid == uid) {
            students.splice(i, 1);
            break;
          }
        }
      } else {
        this.$Modal.confirm({
          title: "提示",
          content: "<p>清空后，已选的数据无法恢复，是否确认？</p>",
          onOk: () => {
            this.students = [];
          }
        });
      }
    },
    submitForm(name) {
      this.$refs[name].validate(valid => {
        if (!valid) {
          return;
        } else {
          if (
            this.exam.is_start_notice == 1 &&
            this.exam.notice_before_time == 0
          ) {
            this.$Message.error("请输入提前通知时间");
            return;
          }
          let params = {};
          for (let i in this.exam) {
            if (i == "uid" && this.exam.uid == "1") {
              params.uid = this.$pub.splitStr(this.students, "uid");
              if (params.uid == "") {
                this.$Message.error("请选择学员");
                return;
              }
            } else if (i == "papers") {
              params.exam_id = this.exam.papers[0].id;
            }else if (i == "classify_ids") {
              params.classify_id = this.exam.classify_ids[1] || this.exam.classify_ids[0];
            } else if (
              i == "is_start_notice" &&
              this.exam.is_start_notice == 2
            ) {
              params.notice_before_time = 0;
              params.is_start_notice = "2";
            } else {
              params[i] = this.exam[i];
            }
          }
          params.price = params.price  * 100;
          params.simulation_type = 1;
          params.repeat_times = -1;
          if(!params.is_related_course){
            params.related_course_id = 0;
          }
          if(params.is_free==2){
            params.price=0;
          }
          if( this.id ) {
            this.$http.put(`/api/exam/packageSimulation/` + this.id , params).then(() => {
              this.$router.push({
                name: "QuestionExamManage"
              });
            });
          }else{
            this.$http.post(`/api/exam/packageSimulation`, params).then(() => {
              this.$Message.createSuccess();
              this.$router.push({
                name: "QuestionExamManage"
              });
            });
          }

        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.choose-studens {
  padding-left: 60px;
  span {
    padding-left: 20px;
    color: #2d8cf0;
    cursor: pointer;
  }
}
.attr-select{
  max-width: 400px;
}
</style>
